import { render, staticRenderFns } from "./whiteboard.fabric.vue?vue&type=template&id=35871a52&"
import script from "./whiteboard.fabric.vue?vue&type=script&lang=js&"
export * from "./whiteboard.fabric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports